import * as React from "react";
import { useCallback, useMemo } from "react";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import usePluginEntities from "hooks/usePluginEntities";
import { Select } from "components/common";
import { Input } from "components/bootstrap";
import { useFetchCacheTypes } from "components/lookup-tables/hooks/useLookupTablesAPI";
function CacheTypeSelect({ cacheConfigType, onCacheChange }) {
  const { types, fetchingCacheTypes } = useFetchCacheTypes();
  const plugins = usePluginEntities("lookupTableCaches");
  const cachePlugins = Object.fromEntries(plugins.map((p) => [p.type, p]));
  const sortedCaches = useMemo(() => {
    if (!fetchingCacheTypes) {
      return Object.keys(types).map((key) => {
        const typeItem = types[key];
        if (!cachePlugins[typeItem.type]) {
          console.error(`Plugin component for cache type ${typeItem.type} is missing - invalid or missing plugin?`);
          return {
            value: typeItem.type,
            disabled: true,
            label: `${typeItem.type} - missing or invalid plugin`
          };
        }
        return {
          value: typeItem.type,
          label: cachePlugins[typeItem.type].displayName
        };
      }).sort((a, b) => naturalSort(a.label.toLowerCase(), b.label.toLowerCase()));
    }
    return [];
  }, [fetchingCacheTypes, types, cachePlugins]);
  const handleTypeSelect = useCallback(
    (cacheType) => {
      const defaultConfig = { ...types[cacheType].default_config };
      onCacheChange({
        id: null,
        title: "",
        name: "",
        description: "",
        config: defaultConfig
      });
    },
    [onCacheChange, types]
  );
  return /* @__PURE__ */ React.createElement(Input, { id: "cache-type-select", label: "Cache Type", required: true, help: "The type of cache to configure." }, /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder: "Select Cache Type",
      clearable: false,
      options: sortedCaches,
      onChange: handleTypeSelect,
      value: cacheConfigType
    }
  ));
}
export default CacheTypeSelect;
